/*
 * @Description: 功能描述
 * @Author: yy
 * @Date: 2019-12-03 17:53:34
 * @LastEditors: yy
 * @LastEditTime: 2019-12-04 10:40:58
 */
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './Table.css';

class Table extends React.Component {
  render() {
    const header = this.props.header
    const body = this.props.body
    return (
      <table className={s.table} cellSpacing="0">
        <thead>
          {header && header()}
        </thead>
        <tbody>
          {body && body()}
        </tbody>
      </table>
    );
  }
}

export default withStyles(s)(Table);



// WEBPACK FOOTER //
// src/routes/customChart/Table/Table.js